<template>
  <div class="fill-details">
    <div id="left-pane">
      <div class="test-details">
        <img id="image" src="../assets/fill-details.svg" alt="Fill Details" />
        <p id="sample-test">{{ $store.state.test.name }}</p>
        <table rules="rows" class="parent-test-details">
          <tr>
            <td class="test-details-left-column">By</td>
            <td class="test-details-right-column" style="color: #0988F4;">
              {{ $store.state.test.companyName }}
            </td>
          </tr>
          <tr>
            <td class="test-details-left-column">Duration</td>
            <td class="test-details-right-column">
              {{ $store.getters.getDuration }}
            </td>
          </tr>
          <tr>
            <td class="test-details-left-column">Opens At</td>
            <td class="test-details-right-column">
              {{ $store.getters.getFormattedDate }}
            </td>
          </tr>
          <tr>
            <td class="test-details-left-column">Ends At</td>
            <td class="test-details-right-column">
              {{ $store.getters.getFormattedEndDate }}
            </td>
          </tr>
        </table>
      </div>
      <div class="help-section">
        <hr class="horizontal-line" />
        <div class="help-div">
          <p id="help-support">Help and support</p>
          <p id="contact-administrator">
            Please contact the administrator at
            <a
              href="mailto:headstart-support@infocusp.com"
              target="_top"
              style="color: #319BF5"
              >headstart-support@infocusp.com</a
            >
          </p>
        </div>
      </div>
    </div>
    <div class="right-pane">
      <div class="test-not-started-container">
        <div class="timer-div">
          <img
            class="timer-img"
            src="../assets/test_status/test_ended.svg"
            alt="Test Ended"
          />
        </div>
        <div class="msg-container">
          <div class="msg-div">
            <h2>You are late for the test, test has already ended !!</h2>
            <img src="../assets/hs_logo_text.svg" alt="HeadStart" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TestEnded',
}
</script>

<style scoped>
.fill-details {
  display: flex;
  margin-top: 64px;
  flex: 1;
  max-height: calc(100% - 64px);
}

#left-pane {
  background: #ffffff;
  box-shadow: inset -1px 0 0 0 #a8b2c6;
  display: flex;
  flex: 1;
  flex-direction: column;
  max-width: 376px;
}

#image {
  display: block;
  margin: 48px auto;
  height: 214px;
  width: 240px;
}

#sample-test {
  font-family: Roboto-Medium;
  font-size: 21px;
  color: #616262;
  letter-spacing: 0;
  margin-left: 32px;
}

.test-details-right-column {
  font-family: Roboto-Medium;
  color: #9b9b9b;
  letter-spacing: 0;
  padding: 16px 0;
}

.test-details-left-column {
  font-family: Roboto-Regular;
  color: #9b9b9b;
  letter-spacing: 0;
  padding: 0 32px;
}

.parent-test-details {
  border: none;
  margin-right: 32px;
  width: 326px;
}

.parent-test-details tr {
  border-top: solid thin;
  border-bottom: solid thin;
  border-color: #efeef3;
}

.horizontal-line {
  width: 326px;
  border: 0.5px solid #efeef3;
  padding-left: 18px;
  margin-right: 30px;
  margin-bottom: 8px;
}

.help-div {
  padding: 0px 32px;
  font-family: Roboto-Bold;
  letter-spacing: 0;
  font-size: 14px;
  margin-bottom: 42px;
}

.help-section {
  margin-top: auto;
}

#contact-administrator {
  font-family: Roboto-Regular;
  color: #9b9b9b;
  line-height: 20px;
}

#help-support {
  margin-top: 24px;
  font-family: Roboto-Bold;
  color: #616262;
  letter-spacing: 0;
}

.right-pane {
  display: flex;
  flex: 1;
  text-align: center;
  background: #f2f2f2;
  color: #69758b;
  height: 100%;
  overflow-y: auto;
  flex-direction: column;
}

.test-not-started-container {
  display: flex;
  flex: 1;
  flex-direction: column;
}

.timer-div {
  position: relative;
  background: #f66957;
}

.timer-div .timer-img {
  padding: 32px;
  width: 420px;
  height: 420px;
}

.msg-container {
  display: flex;
  flex: 1;
  background: #ffffff;
}

.msg-div {
  display: flex;
  flex-direction: column;
  margin: 120px auto 0 auto;
}

.msg-div img {
  margin-top: 24px;
}

@media only screen and (max-width: 1440px) {
  .msg-div {
    margin: 60px auto 0 auto;
  }

  .timer-div .timer-img {
    padding: 16px;
    width: 360px;
    height: 360px;
  }
  .test-details-right-column {
    padding: 10px 0;
  }
}
</style>
